import { openBlock as e, createElementBlock as r, createElementVNode as o } from "vue";
function a(t, n) {
  return e(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, [
    o("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8 16l4-4m0 0l4 4m-4-4v9m8-4.257A5.5 5.5 0 0016.5 7a.62.62 0 01-.534-.302 7.5 7.5 0 10-11.78 9.096"
    })
  ]);
}
export {
  a as default
};
